<div class="wrapper wrapper-content" *ngIf="isLoaded()">
  <div class="container-fluid p-0">
    <div class="row p-0">
      <div class="col-12">
        <formPlyca #formPlycaRef1 [formConfig]="formConfig" *ngIf="formConfig" [manageWaitService]=false>
        </formPlyca>
      </div>
    </div>
  </div>
</div>